// Common Components
import HEADER_01 from './HEADER_01.json';
import FOOTER_01 from './FOOTER_01.json';

// Hero Components
import HERO_01 from './HERO_01.json';
import HERO_02 from './HERO_02.json';
import HERO_03 from './HERO_03.json';
import HERO_04 from './HERO_04.json';
import HERO_05 from './HERO_05.json';
import HERO_06 from './HERO_06.json';

// About Components
import ABOUT_01 from './ABOUT_01.json';
import ABOUT_02 from './ABOUT_02.json';
import ABOUT_03 from './ABOUT_03.json';
import ABOUT_04 from './ABOUT_04.json';
import ABOUT_05 from './ABOUT_05.json';
import ABOUT_06 from './ABOUT_06.json';

// Services Components
import SERVICES_01 from './SERVICES_01.json';
import SERVICES_02 from './SERVICES_02.json';
import SERVICES_03 from './SERVICES_03.json';

// Features Components
import FEATURES_01 from './FEATURES_01.json';
import FEATURES_02 from './FEATURES_02.json';
import FEATURES_03 from './FEATURES_03.json';
import FEATURES_04 from './FEATURES_04.json';
import FEATURES_05 from './FEATURES_05.json';
import FEATURES_06 from './FEATURES_06.json';

// Testimonial Components
import TESTIMONIAL_01 from './TESTIMONIAL_01.json';
import TESTIMONIAL_02 from './TESTIMONIAL_02.json';
import TESTIMONIAL_03 from './TESTIMONIAL_03.json';

// Contact Components
import CONTACT_01 from './CONTACT_01.json';
import CONTACT_02 from './CONTACT_02.json';
import CONTACT_03 from './CONTACT_03.json';
import CONTACT_04 from './CONTACT_04.json';
import CONTACT_05 from './CONTACT_05.json';
import CONTACT_06 from './CONTACT_06.json';

// CTA Components
import CTA_01 from './CTA_01.json';
import CTA_02 from './CTA_02.json';
import CTA_03 from './CTA_03.json';
import CTA_05 from './CTA_05.json';

// FAQ Components
import FAQ_01 from './FAQ_01.json';
import FAQ_02 from './FAQ_02.json';
import FAQ_03 from './FAQ_03.json';
import FAQ_05 from './FAQ_05.json';

// Pricing Components
import PRICING_01 from './PRICING_01.json';
import PRICING_02 from './PRICING_02.json';
import PRICING_03 from './PRICING_03.json';

// Stats Components
import STATS_01 from './STATS_01.json';
import STATS_02 from './STATS_02.json';
import STATS_03 from './STATS_03.json';

// Logo/Clients Components
import LOGOS_01 from './LOGOS_01.json';
import LOGOS_02 from './LOGOS_02.json';
import LOGOS_03 from './LOGOS_03.json';

// Content Components
import CONTENT_01 from './CONTENT_01.json';
import CONTENT_02 from './CONTENT_02.json';
import CONTENT_03 from './CONTENT_03.json';
import CONTENT_04 from './CONTENT_04.json';
import CONTENT_05 from './CONTENT_05.json';
import CONTENT_06 from './CONTENT_06.json';

// Newsletter Components
import NEWSLETTER_01 from './NEWSLETTER_01.json';
import NEWSLETTER_02 from './NEWSLETTER_02.json';
import NEWSLETTER_03 from './NEWSLETTER_03.json';

// Map Components
import MAP_01 from './MAP_01.json';
import MAP_02 from './MAP_02.json';
import MAP_03 from './MAP_03.json';

// Team Components
import TEAM_01 from './TEAM_01.json';
import TEAM_02 from './TEAM_02.json';
import TEAM_03 from './TEAM_03.json';

// Gallery Components
import GALLERY_01 from './GALLERY_01.json';
import GALLERY_02 from './GALLERY_02.json';
import GALLERY_03 from './GALLERY_03.json';
import GALLERY_04 from './GALLERY_04.json';
import GALLERY_05 from './GALLERY_05.json';
import GALLERY_06 from './GALLERY_06.json';

// Hours Components
import HOURS_01 from './HOURS_01.json';
import HOURS_02 from './HOURS_02.json';
import HOURS_03 from './HOURS_03.json';

// Menu Components
import MENU_01 from './MENU_01.json';
import MENU_02 from './MENU_02.json';
import MENU_03 from './MENU_03.json';

// === KALE THEME ===
import KALE_HEADER_01 from './KALE_HEADER_01.json';
import KALE_HERO_01 from './KALE_HERO_01.json';
import KALE_ABOUT_01 from './KALE_ABOUT_01.json';
import KALE_SERVICES_01 from './KALE_SERVICES_01.json';
import KALE_FEATURES_01 from './KALE_FEATURES_01.json';
import KALE_TESTIMONIALS_01 from './KALE_TESTIMONIALS_01.json';
import KALE_PRICING_01 from './KALE_PRICING_01.json';
import KALE_CTA_01 from './KALE_CTA_01.json';
import KALE_FAQ_01 from './KALE_FAQ_01.json';
import KALE_CONTACT_01 from './KALE_CONTACT_01.json';
import KALE_TEAM_01 from './KALE_TEAM_01.json';
import KALE_PROJECTS_01 from './KALE_PROJECTS_01.json';
import KALE_STATS_01 from './KALE_STATS_01.json';
import KALE_MENU_01 from './KALE_MENU_01.json';
import KALE_MAP_01 from './KALE_MAP_01.json';
import KALE_CONTENT_01 from './KALE_CONTENT_01.json';
import KALE_NEWSLETTER_01 from './KALE_NEWSLETTER_01.json';
import KALE_HOURS_01 from './KALE_HOURS_01.json';
import KALE_FOOTER_01 from './KALE_FOOTER_01.json';

// === CLIARO THEME ===
import CLIARO_HEADER_01 from './CLIARO_HEADER_01.json';
import CLIARO_HERO_01 from './CLIARO_HERO_01.json';
import CLIARO_ABOUT_01 from './CLIARO_ABOUT_01.json';
import CLIARO_SERVICES_01 from './CLIARO_SERVICES_01.json';
import CLIARO_FEATURES_01 from './CLIARO_FEATURES_01.json';
import CLIARO_TESTIMONIALS_01 from './CLIARO_TESTIMONIALS_01.json';
import CLIARO_PRICING_01 from './CLIARO_PRICING_01.json';
import CLIARO_CTA_01 from './CLIARO_CTA_01.json';
import CLIARO_FAQ_01 from './CLIARO_FAQ_01.json';
import CLIARO_CONTACT_01 from './CLIARO_CONTACT_01.json';
import CLIARO_TEAM_01 from './CLIARO_TEAM_01.json';
import CLIARO_GALLERY_01 from './CLIARO_GALLERY_01.json';
import CLIARO_STATS_01 from './CLIARO_STATS_01.json';
import CLIARO_MENU_01 from './CLIARO_MENU_01.json';
import CLIARO_MAP_01 from './CLIARO_MAP_01.json';
import CLIARO_CONTENT_01 from './CLIARO_CONTENT_01.json';
import CLIARO_NEWSLETTER_01 from './CLIARO_NEWSLETTER_01.json';
import CLIARO_HOURS_01 from './CLIARO_HOURS_01.json';
import CLIARO_FOOTER_01 from './CLIARO_FOOTER_01.json';

// === STYLIST THEME ===
import STYLIST_HEADER_01 from './STYLIST_HEADER_01.json';
import STYLIST_HERO_01 from './STYLIST_HERO_01.json';
import STYLIST_ABOUT_01 from './STYLIST_ABOUT_01.json';
import STYLIST_SERVICES_01 from './STYLIST_SERVICES_01.json';
import STYLIST_FEATURES_01 from './STYLIST_FEATURES_01.json';
import STYLIST_TESTIMONIAL_01 from './STYLIST_TESTIMONIAL_01.json';
import STYLIST_PRICING_01 from './STYLIST_PRICING_01.json';
import STYLIST_CTA_01 from './STYLIST_CTA_01.json';
import STYLIST_FAQ_01 from './STYLIST_FAQ_01.json';
import STYLIST_CONTACT_01 from './STYLIST_CONTACT_01.json';
import STYLIST_TEAM_01 from './STYLIST_TEAM_01.json';
import STYLIST_GALLERY_01 from './STYLIST_GALLERY_01.json';
import STYLIST_STATS_01 from './STYLIST_STATS_01.json';
import STYLIST_MENU_01 from './STYLIST_MENU_01.json';
import STYLIST_MAP_01 from './STYLIST_MAP_01.json';
import STYLIST_CONTENT_01 from './STYLIST_CONTENT_01.json';
import STYLIST_NEWSLETTER_01 from './STYLIST_NEWSLETTER_01.json';
import STYLIST_HOURS_01 from './STYLIST_HOURS_01.json';
import STYLIST_FOOTER_01 from './STYLIST_FOOTER_01.json';

// === ZYPGO THEME ===
import ZYPGO_HEADER_01 from './ZYPGO_HEADER_01.json';
import ZYPGO_HERO_01 from './ZYPGO_HERO_01.json';
import ZYPGO_ABOUT_01 from './ZYPGO_ABOUT_01.json';
import ZYPGO_SERVICES_01 from './ZYPGO_SERVICES_01.json';
import ZYPGO_FEATURES_01 from './ZYPGO_FEATURES_01.json';
import ZYPGO_TESTIMONIAL_01 from './ZYPGO_TESTIMONIAL_01.json';
import ZYPGO_PRICING_01 from './ZYPGO_PRICING_01.json';
import ZYPGO_CTA_01 from './ZYPGO_CTA_01.json';
import ZYPGO_FAQ_01 from './ZYPGO_FAQ_01.json';
import ZYPGO_CONTACT_01 from './ZYPGO_CONTACT_01.json';
import ZYPGO_TEAM_01 from './ZYPGO_TEAM_01.json';
import ZYPGO_GALLERY_01 from './ZYPGO_GALLERY_01.json';
import ZYPGO_STATS_01 from './ZYPGO_STATS_01.json';
import ZYPGO_MENU_01 from './ZYPGO_MENU_01.json';
import ZYPGO_MAP_01 from './ZYPGO_MAP_01.json';
import ZYPGO_CONTENT_01 from './ZYPGO_CONTENT_01.json';
import ZYPGO_NEWSLETTER_01 from './ZYPGO_NEWSLETTER_01.json';
import ZYPGO_HOURS_01 from './ZYPGO_HOURS_01.json';
import ZYPGO_FOOTER_01 from './ZYPGO_FOOTER_01.json';

// Export all components as object
export const componentTemplates = {
  HEADER_01,
  FOOTER_01,
  HERO_01, HERO_02, HERO_03, HERO_04, HERO_05, HERO_06,
  ABOUT_01, ABOUT_02, ABOUT_03, ABOUT_04, ABOUT_05, ABOUT_06,
  SERVICES_01, SERVICES_02, SERVICES_03,
  FEATURES_01, FEATURES_02, FEATURES_03, FEATURES_04, FEATURES_05, FEATURES_06,
  TESTIMONIAL_01, TESTIMONIAL_02, TESTIMONIAL_03,
  CONTACT_01, CONTACT_02, CONTACT_03, CONTACT_04, CONTACT_05, CONTACT_06,
  CTA_01, CTA_02, CTA_03, CTA_05,
  FAQ_01, FAQ_02, FAQ_03, FAQ_05,
  PRICING_01, PRICING_02, PRICING_03,
  STATS_01, STATS_02, STATS_03,
  LOGOS_01, LOGOS_02, LOGOS_03,
  CONTENT_01, CONTENT_02, CONTENT_03, CONTENT_04, CONTENT_05, CONTENT_06,
  NEWSLETTER_01, NEWSLETTER_02, NEWSLETTER_03,
  MAP_01, MAP_02, MAP_03,
  TEAM_01, TEAM_02, TEAM_03,
  GALLERY_01, GALLERY_02, GALLERY_03, GALLERY_04, GALLERY_05, GALLERY_06,
  HOURS_01, HOURS_02, HOURS_03,
  MENU_01, MENU_02, MENU_03,

  // Kale theme (19)
  KALE_HEADER_01, KALE_HERO_01, KALE_ABOUT_01, KALE_SERVICES_01,
  KALE_FEATURES_01, KALE_TESTIMONIALS_01, KALE_PRICING_01, KALE_CTA_01,
  KALE_FAQ_01, KALE_CONTACT_01, KALE_TEAM_01, KALE_PROJECTS_01,
  KALE_STATS_01, KALE_MENU_01, KALE_MAP_01, KALE_CONTENT_01,
  KALE_NEWSLETTER_01, KALE_HOURS_01, KALE_FOOTER_01,

  // Cliaro theme (19)
  CLIARO_HEADER_01, CLIARO_HERO_01, CLIARO_ABOUT_01, CLIARO_SERVICES_01,
  CLIARO_FEATURES_01, CLIARO_TESTIMONIALS_01, CLIARO_PRICING_01, CLIARO_CTA_01,
  CLIARO_FAQ_01, CLIARO_CONTACT_01, CLIARO_TEAM_01, CLIARO_GALLERY_01,
  CLIARO_STATS_01, CLIARO_MENU_01, CLIARO_MAP_01, CLIARO_CONTENT_01,
  CLIARO_NEWSLETTER_01, CLIARO_HOURS_01, CLIARO_FOOTER_01,

  // Stylist theme (19)
  STYLIST_HEADER_01, STYLIST_HERO_01, STYLIST_ABOUT_01, STYLIST_SERVICES_01,
  STYLIST_FEATURES_01, STYLIST_TESTIMONIAL_01, STYLIST_PRICING_01, STYLIST_CTA_01,
  STYLIST_FAQ_01, STYLIST_CONTACT_01, STYLIST_TEAM_01, STYLIST_GALLERY_01,
  STYLIST_STATS_01, STYLIST_MENU_01, STYLIST_MAP_01, STYLIST_CONTENT_01,
  STYLIST_NEWSLETTER_01, STYLIST_HOURS_01, STYLIST_FOOTER_01,

  // Zypgo theme (19)
  ZYPGO_HEADER_01, ZYPGO_HERO_01, ZYPGO_ABOUT_01, ZYPGO_SERVICES_01,
  ZYPGO_FEATURES_01, ZYPGO_TESTIMONIAL_01, ZYPGO_PRICING_01, ZYPGO_CTA_01,
  ZYPGO_FAQ_01, ZYPGO_CONTACT_01, ZYPGO_TEAM_01, ZYPGO_GALLERY_01,
  ZYPGO_STATS_01, ZYPGO_MENU_01, ZYPGO_MAP_01, ZYPGO_CONTENT_01,
  ZYPGO_NEWSLETTER_01, ZYPGO_HOURS_01, ZYPGO_FOOTER_01,
};

// Export as array for iteration
export const componentList = Object.values(componentTemplates);

// Group components by category (auto-generated from componentList)
export const componentsByCategory = componentList.reduce((acc, comp) => {
  const cat = (comp.category || 'other').toLowerCase();
  if (!acc[cat]) acc[cat] = [];
  acc[cat].push(comp);
  return acc;
}, {});

// Default style guide - Organic Luxury Green
export const defaultStyleGuide = {
  colors: {
    primary: "#059669",      // Emerald - rich, sophisticated green
    secondary: "#d97706",    // Amber - warm complementary accent
    background: "#fafdf7",   // Soft cream with subtle warmth
    text: "#0c1f17",         // Deep forest - organic black alternative
    muted: "#5f7367"         // Sage gray - green undertones
  },
  typography: {
    heading: {
      font_family: "Outfit",             // Clean geometric with personality
      font_weight: 700
    },
    body: {
      font_family: "DM Sans",            // Friendly, highly readable
      font_weight: 400
    }
  },
  ui: {
    button: {
      border_radius: "10px",             // Refined, not overly rounded
      padding: "14px 28px",              // Generous touch targets
      background: "primary",
      text_color: "#ffffff",
      font_weight: "600",                // Semi-bold for presence
      box_shadow: "0 4px 14px 0 rgba(5, 150, 105, 0.3)"  // Emerald glow
    },
    input: {
      border_radius: "8px",              // Subtle rounding
      border_color: "#d4e5d8",           // Soft sage border
      padding: "14px 16px",              // Comfortable padding
      background: "#ffffff",
      focus_border: "#059669",           // Emerald on focus
      box_shadow: "0 1px 3px 0 rgba(12, 31, 23, 0.06)"  // Forest shadow
    }
  }
};

// Generate CSS variables from style guide
// Handles both full format (typography.heading.font_family) and simplified format (fonts.heading)
export function generateCSSVariables(styleGuide) {
  // Normalize typography - handle both formats
  const headingFont = styleGuide.typography?.heading?.font_family
    || styleGuide.fonts?.heading
    || 'Outfit';
  const headingWeight = styleGuide.typography?.heading?.font_weight || 700;
  const bodyFont = styleGuide.typography?.body?.font_family
    || styleGuide.fonts?.body
    || 'DM Sans';
  const bodyWeight = styleGuide.typography?.body?.font_weight || 400;

  // Normalize buttons - handle both formats
  const btnRadius = styleGuide.ui?.button?.border_radius
    || styleGuide.buttons?.borderRadius
    || '10px';
  const btnPadding = styleGuide.ui?.button?.padding
    || styleGuide.buttons?.padding
    || '14px 28px';
  const btnTextColor = styleGuide.ui?.button?.text_color || '#ffffff';
  const btnFontWeight = styleGuide.ui?.button?.font_weight || '600';
  const btnShadow = styleGuide.ui?.button?.box_shadow || 'none';

  // Normalize inputs - use defaults if not present
  const inputRadius = styleGuide.ui?.input?.border_radius || '8px';
  const inputBorder = styleGuide.ui?.input?.border_color || '#d4e5d8';
  const inputPadding = styleGuide.ui?.input?.padding || '14px 16px';
  const inputBg = styleGuide.ui?.input?.background || '#ffffff';
  const inputFocusBorder = styleGuide.ui?.input?.focus_border || styleGuide.colors?.primary || '#059669';
  const inputShadow = styleGuide.ui?.input?.box_shadow || 'none';

  return `
    :root {
      /* Colors */
      --color-primary: ${styleGuide.colors?.primary || '#059669'};
      --color-secondary: ${styleGuide.colors?.secondary || '#d97706'};
      --color-background: ${styleGuide.colors?.background || '#fafdf7'};
      --color-text: ${styleGuide.colors?.text || '#0c1f17'};
      --color-muted: ${styleGuide.colors?.muted || '#5f7367'};

      /* Typography */
      --font-heading: '${headingFont}', sans-serif;
      --font-heading-weight: ${headingWeight};
      --font-body: '${bodyFont}', sans-serif;
      --font-body-weight: ${bodyWeight};

      /* Buttons */
      --btn-radius: ${btnRadius};
      --btn-padding: ${btnPadding};
      --btn-bg: var(--color-primary);
      --btn-text: ${btnTextColor};
      --btn-font-weight: ${btnFontWeight};
      --btn-shadow: ${btnShadow};

      /* Inputs */
      --input-radius: ${inputRadius};
      --input-border: ${inputBorder};
      --input-padding: ${inputPadding};
      --input-bg: ${inputBg};
      --input-focus-border: ${inputFocusBorder};
      --input-shadow: ${inputShadow};
    }
  `;
}

// Get HTML template for a component code
export function getHtmlTemplate(componentCode) {
  const template = componentTemplates[componentCode];
  return template?.html || null;
}

// Get component by code
export function getComponentByCode(code) {
  return componentTemplates[code] || null;
}

// Get sample data for a component code - use this as fallback when AI doesn't generate content
export function getSampleData(componentCode) {
  const template = componentTemplates[componentCode];
  return template?.sample_data_json || null;
}

// Get placeholder schema for a component code
export function getPlaceholderSchema(componentCode) {
  const template = componentTemplates[componentCode];
  return template?.placeholder_json || null;
}

// Get components by category
export function getComponentsByCategory(category) {
  return componentsByCategory[category] || [];
}

/**
 * Render a component dynamically using its HTML template, content, and style guide
 * @param {string} componentCode - e.g., "HEADER_01", "HERO_01"
 * @param {object} content - Content to fill placeholders (AI-generated or sample_data_json)
 * @param {object} styleGuide - Style guide with colors, typography, ui settings
 * @returns {string} Rendered HTML string with all placeholders replaced and CSS variables applied
 */
// Lighten a hex color by mixing with white
function lightenHex(hex, amount = 0.8) {
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const lr = Math.round(r + (255 - r) * amount);
  const lg = Math.round(g + (255 - g) * amount);
  const lb = Math.round(b + (255 - b) * amount);
  return [lr, lg, lb].map(c => c.toString(16).padStart(2, '0')).join('');
}

// Replace hardcoded green placeholder colors in placehold.co URLs with style guide primary
function recolorPlaceholders(html, styleGuide) {
  const primary = (styleGuide?.colors?.primary || defaultStyleGuide.colors.primary).replace('#', '');
  const lightPrimary = lightenHex(primary, 0.8);
  // Map: all hardcoded emerald shades → light tint for consistent look
  const replacements = [
    ['10b981', lightPrimary],   // emerald-500 → light primary
    ['059669', lightPrimary],   // emerald-600 → light primary
    ['047857', lightPrimary],   // emerald-700 → light primary
    ['d1fae5', lightPrimary],   // emerald-100 → light primary
  ];
  let result = html;
  for (const [from, to] of replacements) {
    result = result.replace(
      new RegExp(`(placehold\\.co/[0-9]+x[0-9]+/)${from}`, 'g'),
      `$1${to}`
    );
  }
  return result;
}

export function renderComponentDynamic(componentCode, content, styleGuide) {
  // Get the HTML template
  const template = componentTemplates[componentCode];
  if (!template || !template.html) {
    return `<div style="padding: 40px; text-align: center; color: #666;">Component ${componentCode} not found</div>`;
  }

  // Merge content with sample_data_json - sample data provides defaults for missing fields
  const sampleData = template.sample_data_json || {};
  const providedContent = content || {};

  // Replace placeholder logos with sample data logos
  const finalContent = { ...sampleData };
  for (const [key, value] of Object.entries(providedContent)) {
    // Skip placeholder logos - use sample data instead
    if (key.includes('logo') && typeof value === 'string' && value.includes('placehold.co')) {
      continue;
    }
    // Allow empty strings for nav/link fields (to clear unused slots)
    const isNavField = /^(nav_link_|link\d|support\d|col_?\d)/.test(key);
    if (isNavField && value !== null && value !== undefined) {
      finalContent[key] = value;
    } else if (value !== null && value !== undefined && value !== '') {
      finalContent[key] = value;
    }
  }

  // Start with the HTML template
  let rendered = template.html;

  // Replace all {{placeholders}} with content values
  for (const [key, value] of Object.entries(finalContent)) {
    if (value !== null && value !== undefined) {
      rendered = rendered.replace(new RegExp(`{{${key}}}`, 'g'), String(value));
    }
  }

  // Replace any remaining unreplaced placeholders with empty string or placeholder text
  rendered = rendered.replace(/{{([^}]+)}}/g, (_match, placeholder) => {
    // Check if sample data has this placeholder (but not for nav/link fields which were intentionally cleared)
    const isNavPlaceholder = /^(nav_link_|link\d|support\d|col_?\d)/.test(placeholder);
    if (!isNavPlaceholder && sampleData[placeholder]) {
      return String(sampleData[placeholder]);
    }
    // For image placeholders, use a placeholder image
    if (placeholder.includes('image') || placeholder.includes('logo') || placeholder.includes('photo')) {
      return 'https://placehold.co/600x400/e2e8f0/64748b?text=Image';
    }
    // For other placeholders, return empty or a placeholder
    return '';
  });

  // Strip empty navigation elements (headers/footers with unused nav slots)
  // Remove <a> tags that have no visible text content (only whitespace/spans)
  rendered = rendered.replace(/<a\b[^>]*>\s*(<span[^>]*>\s*<\/span>\s*)*<\/a>/gi, '');
  // Remove <li> tags that are now empty (contained only a removed <a>)
  rendered = rendered.replace(/<li[^>]*>\s*<\/li>/gi, '');

  // Generate CSS variables from style guide
  const cssVars = generateCSSVariables(styleGuide || defaultStyleGuide);

  // Replace hardcoded placeholder colors with style guide colors
  rendered = recolorPlaceholders(rendered, styleGuide || defaultStyleGuide);

  // Wrap the rendered HTML with a style tag containing CSS variables
  const wrappedHtml = `
    <style>${cssVars}</style>
    ${rendered}
  `;

  return wrappedHtml;
}

/**
 * Get complete component data including template, content, and render function
 * @param {string} componentCode
 * @param {object} contentOverride - Optional content to override sample data
 * @returns {object} Component data with html, content, placeholder_json
 */
export function getComponentData(componentCode, contentOverride = null) {
  const template = componentTemplates[componentCode];
  if (!template) return null;

  return {
    code: componentCode,
    title: template.title,
    description: template.description,
    category: template.category,
    html: template.html,
    placeholderSchema: template.placeholder_json,
    content: contentOverride || template.sample_data_json,
    sampleData: template.sample_data_json
  };
}

// Alias for backward compatibility - some files import renderComponent
export { renderComponentDynamic as renderComponent };

export default componentTemplates;
